import { Component, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { NoRecordFound, NoRecordType } from '../../../../../models/common/table/table-config';
import { FormActionComponent } from '../../../forms/components/form-action/form-action.component';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { FormStoreService } from '../../../../../state/modules/form/form-store.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FORM_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/form';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { ShiftInfoMainService } from '../../services/shift-info-main.service';

@Component({
  standalone: false,
  selector: 'kt-check-pending-form',
  templateUrl: './check-pending-form.component.html',
  styleUrls: ['./check-pending-form.component.scss']
})
export class CheckPendingFormComponent extends ModalBaseClass {

  data : any 
  user_id : null
  loading = signal(false);
  payrollTemplates = [];
  pendingFormList = signal<any[]>([]);
  list: any = [];
  searchText: any;
  subscriptions: Subscription[] = [];
  id;
  lastPayload = {
    page_number: 1,
    page_size: 20,
    global_fields: [],
    global_filter_value: '',
    filter: [],
    sort: [],
    is_all: true,
  };
  totalTemplate;
  constructor(public formStoreService: FormStoreService, private ngbModal: NgbModal , public shiftInfoMainService  : ShiftInfoMainService , public activeModal: NgbActiveModal) {
    super(ngbModal);
  }

  ngOnInit() {
   this.pendingFormList.set(this.data.data.data.pending_forms)
  }
 
  getformList(){
    this.shiftInfoMainService.getPendingFormList(this.user_id).subscribe(res => {
      if(res.data.data && res.data.data.pending_forms){
      this.pendingFormList.set(res.data.data.pending_forms)
      }
      else{
        this.activeModal.close('Submit');
      }
      })
  }
  
  fillForm(form) {
    const componetRef = this.openPopUp(FormActionComponent, { isModalGetByFormId: true, formData: form, viewMode: false, formId: form.form_personal_fk_form_id }, { centered: true, size: 'xl', backdrop: 'static' });
    componetRef.result.then(res => {
      if (res.formFilled) {
        const formPayload = form.form;
        formPayload.form_page = res.form;
        const payload = {
          form_personal_user_id: form.form_personal_user[0].form_personal_user_id,
          form_personal_user_fk_user_id: form.form_personal_user[0].form_personal_user_fk_user_id,
          form_personal_user_details: formPayload,
          form_personal_user_fk_form_personal_id: form.form_personal_user[0].form_personal ? form.form_personal_id : 0,
          type: form && form.form_personal_user[0].form_personal && form.form_personal_user[0].form_personal.form_personal_trg_completed_user_count ?  'ADD' :  'UPDATE',
        }
        this.dispatcFillPersonalForm(payload);
      }
    });
  }
  submit(data) {
    if (data.success) {
      this.getformList()
    }
  }

  dispatcFillPersonalForm(data) {
    this.formStoreService.dispatchFormCommon({
      module: FORM_METHOD_CONSTANT.SUBMIT_PERSONAL_FORM,
      method: API_METHOD_CONSTANTS.UPDATE,
      callback: this.submit.bind(this),
      data,
    });
  }
}

export const noRecordFound: NoRecordFound = {
  type: NoRecordType.BASIC,
  title: 'No record found',
  message: '',
  show: true,
  iconSVG: 'assets/media/iq-svg/animation/More/task_group_template_view_component.json',
  iconSVGClass: '',
}
